<template>
  <div>
    <van-nav-bar
      title="报修及巡检详情"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="form-div">
      <van-field v-model="detail.gasUserNumber" label="用户编号" readonly input-align="right"/>
      <van-field v-model="detail.serviceNumber" label="服务编号" readonly input-align="right"/>
      <van-field label="状态" readonly input-align="right">
        <template #input>
          <span :class="detail.repairState == '已完成' ? 'green' : detail.repairState == '未完成' ? 'orange' : 'blue'">
            {{detail.repairState}}
          </span>
        </template>
      </van-field>
      <van-field v-model="detail.repairCall" label="联系电话" readonly input-align="right"/>
      <van-field v-model="detail.detailedAddress" label="详细地址" readonly input-align="right" autosize type="textarea"/>
      <van-field v-model="detail.repairTypeChina" label="报修类型" readonly input-align="right"/>
      <van-field v-model="detail.userNote" label="用户备注" readonly input-align="right" autosize type="textarea"/>
      <!--<div v-if="isShowEvaluation || detail.feedBackCH" class="label-div">服务评价<span class="required-span">*</span></div>
      <van-field v-model="detail.feedBackCH" v-if="isShowEvaluation || detail.feedBackCH" placeholder="请选择" readonly>
        <template #button>
          <van-button v-if="isShowEvaluation" class="choose-button" @click="chooseServiceEvaluation()">选择</van-button>
        </template>
      </van-field>
      <van-popup v-model="showServiceEvaluationPicker" v-if="isShowEvaluation || detail.feedBackCH" position="bottom" round>
        <van-picker
          show-toolbar
          :columns="serviceEvaluationColumns"
          @confirm="onServiceEvaluationConfirm"
          @cancel="showServiceEvaluationPicker = false"
        />
      </van-popup>
      <div v-if="detail.feedBackCH == '不满意' || detail.feedBackDetailCH" class="label-div">为何不满意<span class="required-span">*</span></div>
      <van-field v-model="detail.feedBackDetailCH" v-if="detail.feedBackCH == '不满意' || detail.feedBackDetailCH" placeholder="请选择" readonly>
        <template #button>
          <van-button v-if="isShowEvaluation" class="choose-button" @click="chooseFeedBackDetail()">选择</van-button>
        </template>
      </van-field>
      <van-popup v-model="showFeedBackDetailPicker" v-if="detail.feedBackCH == '不满意' || detail.feedBackDetailCH" position="bottom" round>
        <van-picker
          show-toolbar
          :columns="feedBackDetailColumns"
          @confirm="onFeedBackDetailConfirm"
          @cancel="showFeedBackDetailPicker = false"
        />
      </van-popup>
      <div v-if="isShowEvaluation" class="button-div">
        <van-button color="#CE0022" class="login-button button-shadow" @click="submitEvaluate()">提交评价</van-button>
      </div>-->
    </div>
  </div>
</template>

<script>
  import { evaluate } from '../../api/repair'

  export default {
    name: 'RepairDetail',
    data () {
      return {
        showServiceEvaluationPicker: false, // 是否展示服务评价选择器
        showFeedBackDetailPicker: false, // 是否展示为何不满意选择器
        serviceEvaluationColumns: [{
          text: '满意',
          value: 'BJG VerySatis'
        }, {
          text: '一般',
          value: 'BJG Satis'
        }, {
          text: '不满意',
          value: 'BJG UnSatis'
        }], // 服务评价列表
        feedBackDetailColumns: [{
          text: '态度不满意',
          value: 'BJG Attitude'
        }, {
          text: '收费不满意',
          value: 'BJG Fee'
        }, {
          text: '时间不满意',
          value: 'BJG Time'
        }, {
          text: '服务不满意',
          value: 'BJG Service'
        }, {
          text: '技术不满意',
          value: 'BJG Tech'
        }, {
          text: '其他不满意',
          value: 'BJG OtherUnSatis'
        }], // 为何不满意列表
        detail: {
          gasUserNumber: '', // 用户编号
          serviceNumber: '', // 服务编号
          repairState: '', // 状态
          repairCall: '', // 联系电话
          detailedAddress: '', // 详细地址
          repairTypeChina: '', // 报修类型
          userNote: '', // 用户备注
          feedBackCH: '', // 服务评价
          feedBack: '', // 服务评价值
          feedBackDetailCH: '', // 为何不满意
          feedBackDetail: '', // 为何不满意值
          canFeedback: 'N' // 能否评价
        }, // 报修详情
        isShowEvaluation: true // 是否显示提交评价按钮
      }
    },
    mounted () {
      this.detail = this.$route.params.detail
      /*if (this.$route.params.detail.canFeedback === 'N') {
        this.isShowEvaluation = false
        if (this.$route.params.detail.feedBack) {
          this.detail.feedBackCH = this.serviceEvaluationColumns.filter(item => item.value === this.$route.params.detail.feedBack)[0].text;
        }
        if (this.$route.params.detail.feedBackDetail) {
          this.detail.feedBackDetailCH = this.feedBackDetailColumns.filter(item => item.value === this.$route.params.detail.feedBackDetail)[0].text;
        }
      } else {
        this.isShowEvaluation = true
      }*/
    },
    methods: {
      // 返回
      onClickLeft () {
        this.$router.go(-1)
      },

      // 显示服务评价选择器
      chooseServiceEvaluation () {
        this.showServiceEvaluationPicker = true
      },

      // 选择服务评价确认
      onServiceEvaluationConfirm (value) {
        this.detail.feedBackCH = value.text
        this.detail.feedBack = value.value
        this.showServiceEvaluationPicker = false
      },

      // 显示为何不满意选择器
      chooseFeedBackDetail () {
        this.showFeedBackDetailPicker = true
      },

      // 选择为何不满意确认
      onFeedBackDetailConfirm (value) {
        this.detail.feedBackDetailCH = value.text
        this.detail.feedBackDetail = value.value
        this.showFeedBackDetailPicker = false
      },

      // 提交评价
      submitEvaluate () {
        let that = this
        if (!that.detail.feedBack) {
          that.$toast('请选择满意度')
        } else if (that.detail.feedBackCH === '不满意' && !that.detail.feedBackDetail) {
          that.$toast('请选择不满意原因')
        } else {
          that.$toast.loading({
            message: '提交中...',
            forbidClick: true,
            duration: 0
          })
          const params = {
            srnum: that.detail.serviceNumber,
            feedback: that.detail.feedBack,
            feedbackDetail: that.detail.feedBackDetail
          }
          if(that.detail.feedBackCH !== '不满意'){
            params.feedbackDetail = ''
          }
          evaluate(params).then(res => {
            if (res.data.success) {
              that.detail.canFeedback = 'N'
              that.isShowEvaluation = false
              that.$toast.success(res.data.message)
            } else {
              that.$toast.fail((res.data.message ? res.data.message : '返回数据异常'))
            }
          }).catch(() => {
            that.$toast.fail('请求评价异常')
          })
        }
      }
    }
  }
</script>

<style scoped>
  .van-cell {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    padding: 12px 0;
    border-bottom: 1px solid rgba(16, 12, 13, 0.0784313725490196);
  }

  /deep/ .van-field__label {
    color: #62667A;
  }

  /deep/ .van-field__control {
    color: #27282E;
  }

  .form-div {
    padding: 0 4%;
  }

  .required-span {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FF7825;
    margin-left: 1px;
  }

  .login-button {
    width: 100%;
    height: 50px;
    border-radius: 8px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 12px;
  }

  .button-shadow {
    box-shadow: 0px 6px 12px rgba(206, 0, 34, 0.3);
  }

  .button-div {
    width: 92%;
    position: absolute;
    bottom: 35px;
  }

  /deep/ .van-field__control--custom {
    flex-direction: column;
    align-items: flex-end;
  }

  .green {
    color: #00AE8D;
  }

  .orange {
    color: #FF6B38;
  }

  .blue {
    color: #005AE3;
  }

  .label-div {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #27282E;
    text-align: left;
    margin-top: 15px;
  }

  .choose-button {
    font-size: 19px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 26px;
    color: #CE0022;
    border: none;
  }
</style>
